import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { CloseButton, Gray500Divider } from "../utils/components";
import { selectApplicationForm } from "../../../../../store/selector";
import { fontWeights, sizes } from "../../../../../constant/styles";
import { AttachmentModal } from "../../../../modals/AttachmentModal";
import { useEnrollmentTracking } from "../hooks/useEnrollmentTracking";

export const SubmittedFormModal = ({ visible, onCancel }) => {
  const { t } = useTranslation();
  const applicationForm = useSelector(selectApplicationForm);
  const { trackPopupImpression, trackButtonClick } = useEnrollmentTracking();

  const applicationFormAttachmentId = applicationForm?.applicationFormAttachmentId;

  // Track modal impression when visible
  useEffect(() => {
    if (visible) {
      trackPopupImpression("view_submitted_form_modal", {
        popup_title: t("patientApplications.enroll.application_form_submission.view_submitted_modal.title"),
        has_attachment: !!applicationFormAttachmentId,
        attachment_name: applicationForm?.attachmentName || null
      });
    }
  }, [visible]);

  const handleClose = () => {
    trackButtonClick(
      "view_submitted_form_modal_close_button",
      {
        button_id: "EE_submitted_form_modal_close",
        button_text: t("patientApplications.enroll.electronic_signatures.close")
      },
      { contentType: "button", feature: "ee_third_step" }
    );
    onCancel();
  };

  return (
    <AttachmentModal
      visible={visible}
      title={t("patientApplications.enroll.application_form_submission.view_submitted_modal.title")}
      description={t("patientApplications.enroll.application_form_submission.view_submitted_modal.description")}
      applicationFormFileName={applicationForm?.attachmentName}
      applicationFormAttachmentId={applicationFormAttachmentId}
    >
      <Gray500Divider style={{ fontSize: sizes.small, fontWeight: fontWeights.semibold }} />
      <div style={{ marginTop: 40, display: "flex", justifyContent: "right" }}>
        <CloseButton onClick={handleClose} id={"EE_submitted_form_modal_close"} />
      </div>
    </AttachmentModal>
  );
};
